// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const LeafLg = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M14 11C11.5778 13.3167 9.15569 19 9.15569 19C9.15569 19 7.46021 14.1802 4 12.334" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.6962 5.52435L20.1222 9.94823C20.3985 12.8181 18.2467 15.3733 15.3769 15.6497C12.5609 15.9208 10.01 13.8625 9.73878 11.0466C9.46768 8.23062 11.5306 5.72803 14.3466 5.45689L19.0634 5.00271C19.3822 4.97201 19.6655 5.20556 19.6962 5.52435Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
